import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function salaryData() {
    return axios.get(`${url}/salary`).then(response => {
       return {
           salaryData: response.data,
       };
    });
}
function defaultPeriod() {
    return axios.get(`${url}/salary/get_default_period`).then(response => {
       return {
           defaultPeriod: response.data,
       };
    });
}

function salaryDataByWeek(week) {
    const payload = JSON.stringify({week});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/salary/week`, payload, options).then(response => {
        return {
            salaryDataByWeek: response.data
        };
    });
}

function reportSalaryData(payload) {
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/salary/report_salary`, payload, options).then(response => {
        return {
            reportSalaryData: response.data
        };
    });
}

function reportExcelSalaryData(payload) {
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        responseType: 'arraybuffer'
    };
    return axios.post(`${url}/salary/report_excel_salary`, payload, options).then(response => {
        return {
            reportExcelSalaryData: response
        };
    });
}

function reportRetoucherSalaryData(payload) {
    return axios.post(`${url}/salary/report_retoucher_salary`, payload).then(response => {
        return {
            reportRetoucherSalaryData: response.data
        };
    });
}

function reportProRetoucherSalaryData(payload) {
    return axios.post(`${url}/salary/report_pro_retoucher_salary`, payload).then(response => {
        return {
            reportProRetoucherSalaryData: response.data
        };
    });
}

function getWeekData(payload) {
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/salary_week/get`, payload, options).then(response => {
        return {
            weekData: response.data
        };
    });
}
function storeWeek(payload) {
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/salary_week/store`, payload, options).then(response => {
        return {
            storeWeekData: response.data
        };
    });
}

function storeAdditionalPayment(payload) {
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/salary/store-additional-payment`, payload, options).then(response => {
        return {
            storeAdditionalPayment: response.data
        };
    });
}

function storeNote(payload) {
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/salary/store-note`, payload, options).then(response => {
        return {
            storeNote: response.data
        };
    });
}

function writePayedRetouchers(payload) {
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/salary/write_payed`, payload, options).then(response => {
        return {
            writePayedRetouchers: response.data
        };
    });
}

export default {
    salaryData,
    salaryDataByWeek,
    defaultPeriod,
    reportSalaryData,
    reportExcelSalaryData,
    reportRetoucherSalaryData,
    reportProRetoucherSalaryData,
    getWeekData,
    storeWeek,
    writePayedRetouchers,
    storeAdditionalPayment,
    storeNote,
};